import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import VideoNotAvailable from '@/images/VideoNotAvailable.svg';
import theme from '@/theme';

const Frame = styled.div`
    align-self: center;
    display: flex;
    width: 100%;
    max-width: 36rem;
    aspect-ratio: 1;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1.6rem;
`;

const Title = styled(Typography)`
    color: ${theme.colors.black.main};
    text-align: center;
`;

export default function VideoUnavailable() {
    return (
        <Frame>
            <MaskedIcon src={VideoNotAvailable} size="5.2rem" />
            <Title variant="h4" title="Video is not available">
                Video is not available
            </Title>
        </Frame>
    );
}
